module.exports = __webpack_public_path__ + "img/icon_sb_select_star_trustpilot_t.ff5fcee.svg";